import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const OneDotTenDotOne = () => {
  return (
    <ChangelogInstance version="1.10.1" date="2019-03-18">
      <li>Fixed a bug where some options were not editable</li>
    </ChangelogInstance>
  );
}

export default OneDotTenDotOne;